<template>
    <div v-if="fournisseurSupport">
      <div class="entete border-entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ getTitle }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{ $t('addEditFournisseurSupport.actions.cancel')}}
              </button>
              <button class="button is-addOrEdit" @click="saveFournisseurSupport()">
                {{ $t('general.button.sauvegarder') }}
              </button>
              <piece-jointe-button
                class="mgr-2"
                :perm="permsFournisseurSupport.maj">
              </piece-jointe-button>
            </div>
          </div>
        </div>
      </div>
      <error-msg-component
        v-if="error"
        :messages="messages"
        :error="error"
        :champs-vide="champsVide"
        :messages-champs-vide="messagesChampsVide"
        @close="error = $event"
        class="mgt-20px"
        title="general.problemOccurred"
        withEmplyFields/>
      <div class="columns mgt-20px">
        <div class="column is-narrow"><logo/></div>
        <div class="column">
          <div class="card">
            <header class="header-card">
              <p>{{ $t('addEditFournisseurSupport.informationsGenerales.title')}}</p>
            </header>
            <div class="card-content">
              <info-generales :data="fournisseurSupport"></info-generales>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card" >
          <p>{{ $t('addEditFournisseurSupport.adresse.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-6">
              <b-field :label="$t('addEditFournisseurSupport.adresse.postalAddress')">
                <adresse
                  :adresse="fournisseurSupport.adressePostale"
                  :tableName="TIERS"
                  adresseName='adressePostale'/>
              </b-field>
            </div>
            <div class="column is-6">
            <b-checkbox
              v-model="fournisseurSupport.adresseFacturationDifferente"
              @input="selectionAdresseFacturationclient()">
              {{ $t('addEditFournisseurSupport.adresse.addressBillingDifferent')}}
            </b-checkbox>
            <adresse
              v-if="fournisseurSupport.adresseFacturationDifferente"
              :adresse="fournisseurSupport.adresseFacturation"
              :tableName="TIERS"
              adresseName="adresseFacturation"
              class="mgt-5px"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('addEditFournisseurSupport.contact.title')}}
          </p>
        </header>
        <div class="card-content">
          <contacts
            :contacts="fournisseurSupport.contacts"
            :client="fournisseurSupport"/>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('addEditFournisseurSupport.informationsBancaires.title')}}
          </p>
        </header>
        <div class="card-content">
          <info-bancaires :data="fournisseurSupport"></info-bancaires>
        </div>
      </div>
      <div class="columns mgt-20px">
        <div class="column is-6">
          <div class="card height-100">
            <header class="header-card">
              <p>
                {{ $t('addEditFournisseurSupport.infoComptable.title')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns is-mutiline">
                <div class="column is-3">
                  <b-field :label="$t('addEditFournisseurSupport.infoComptable.compteComptable')">
                    <b-input v-model="fournisseurSupport.compteComptable"></b-input>
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field :label="$t('editionFournisseur.infoComptable.referenceUniqueMandat')">
                    <b-input v-model="fournisseurSupport.referenceUniqueMandat"></b-input>
                  </b-field>
                </div>
                <div class="column is-5">
                  <b-field :label="$t('editionFournisseur.infoComptable.dateSignatureMandatSepa')">
                    <b-datepicker
                      v-model="fournisseurSupport.dateSignatureMandatSepa"
                      icon="calendar-today"
                      editable
                      show-week-number
                      nearby-selectable-month-days>
                    </b-datepicker>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <info-commande :tiers="fournisseurSupport">
          </info-commande>
        </div>
      </div>

      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('addEditFournisseurSupport.infoBlocagePaiement.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-3">
              <b-field
                :label="$t('addEditFournisseurSupport.infoBlocagePaiement.bloquePaiement')"
                custom-class="mgb-14px">
                <qd-switch
                  v-model="fournisseurSupport.blocageReglement"
                  @input="updateMotifBlocage"
                  class="has-text-icon-more">
                  {{ $t('addEditFournisseurSupport.infoBlocagePaiement.bloque') }}
                </qd-switch>
              </b-field>
            </div>
            <div class="column is-3">
            <parametre-autocomplete
              :label="$t('addEditFournisseurSupport.infoBlocagePaiement.motif')"
              v-model="fournisseurSupport.motifBlocageId"
              :target="constantes.PARAMETRES_KEYS.motifBlocage"
              :disabled="!fournisseurSupport.blocageReglement"
              expanded
            />
</div>
          </div>
        </div>
      </div>

      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('addEditFournisseurSupport.commentaire.title')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns bottom">
            <div class="column is-12">
              <b-field :label="$t('addEditFournisseurSupport.commentaire.commentaire')">
                <textarea
                  v-model="fournisseurSupport.commentairesInternes"
                  class="textarea" rows="6">
                </textarea>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>{{ $t('piecesJointes.attachments')}}</p>
        </header>
        <div class="card-content">
          <pieces-jointes checkPermissions/>
        </div>
      </div>
      <b-modal
        v-model="popUpAvertissement"
        class="modal"
        has-modal-card>
        <pop-up-avertissement
          :msgAvertissements="messagesAvertissement"
          @continuer="$router.push({
            name: 'c.presse.fournisseur_support',
            params: { id: fournisseurSupport.id }
          })">
        </pop-up-avertissement>
      </b-modal>
    </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { get } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
} from '@/configuration/tiers/tiersConf';
import genererClient from '@/services/tiers/genererTiers';
import messageErreur from '@/services/general/messageErreur';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Logo from '@/components/general/Logo';
import Adresse from '@/components/general/adresse';
import adresseGenerer from '@/services/general/genererAdresse';
import contacts from '@/components/clients/clients/editionClient/contacts';
import piecesJointes from '@/components/general/piecesJointes';
import infoGenerales from '@/components/achat/fournisseurSupport/ajoutEdit/infoGenerales';
import infoBancaires from '@/components/achat/fournisseurSupport/ajoutEdit/infoBancaires';
import popUpAvertissement from '@/components/achat/fournisseurSupport/ajoutEdit/p_avertissement';
import { insertTiers, updateTiers } from '@/services/tiers/saveTiers';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/achat/fournisseurSupport/validationFournisseurSupport';
import validationGeneral from '@/services/validation/validation';
import champsFournisseurTranslator from '@/services/tiers/champsFournisseurTranslator';
import inProgress from '@/services/general/inProgress';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import traductionMsgAvertissement from '@/services/achat/fournisseurSupport/traductionMsgAvertissementFournisseurSupport';
import infoCommande from '@/components/commun/tiers/editionTiers/infoCommande';
import { TIERS } from '@/configuration/ville/villeConf';
import initialize from '@/services/tiers/initializeTiers';
import moment from 'moment';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { FOURNISSEUR_SUPPORT } from '@/configuration/presse/permissionsPresseConf';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      TIERS: TIERS,
      fournisseurSupport: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      nomCommercial: null,
      popUpAvertissement: false,
      messagesAvertissement: [],
      permsFournisseurSupport: FOURNISSEUR_SUPPORT,
      constantes: {
        PARAMETRES_KEYS: typesParametres.PARAMETRES_KEYS,
      },
    };
  },
  components: {
    AppBreadcrumb,
    errorMsgComponent,
    Logo,
    Adresse,
    contacts,
    piecesJointes,
    infoGenerales,
    infoBancaires,
    popUpAvertissement,
    infoCommande,
    pieceJointeButton,
    parametreAutocomplete,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getTitle() {
      let title = this.dataAlreadyExist
        ? this.$t('addEditFournisseurSupport.title.edit')
        : this.$t('addEditFournisseurSupport.title.ajout');
      if (this.dataAlreadyExist) title += ' ' + this.nomCommercial;
      return title;
    },
    dataAlreadyExist() {
      return this.fournisseurSupport.id !== undefined && this.fournisseurSupport.id !== null;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('addEditFournisseurSupport.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addEditFournisseurSupport.breadcrumb.liste'), route: { name: 'l.presse.fournisseur_support' }, isActive: false },
        { title: this.dataAlreadyExist ? this.$i18n.t('addEditFournisseurSupport.breadcrumb.edit') : this.$i18n.t('addEditFournisseurSupport.breadcrumb.ajout'), route: { name: '' }, isActive: true },
      ];
    },
    motifBlocage() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.motifBlocage);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateMotifBlocage(blocagePaiement) {
      if (!blocagePaiement) this.fournisseurSupport.motifBlocageId = null;
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async saveFournisseurSupport() {
      this.error = false;
      this.messages = [];
      this.messagesAvertissement = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        let fournisseurSupport = cloneDeep(this.fournisseurSupport);
        fournisseurSupport.sousTypes = [TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT];
        if (!this.dataAlreadyExist) {
          fournisseurSupport.contacts.forEach((el) => {
            delete el.guid;
          });
          fournisseurSupport.societeId = this.societeActiveId;
          fournisseurSupport = await insertTiers(fournisseurSupport);
          await this.setAttachmentElementId({ id: fournisseurSupport.id });
          await this.insertAttachments(fournisseurSupport.id);
          messageSucces(this.$i18n.t('addEditFournisseurSupport.notifications.successCreation'));
        } else {
          fournisseurSupport = await updateTiers(fournisseurSupport);
          await this.updateAttachments(fournisseurSupport.id);
          messageSucces(this.$i18n.t('addEditFournisseurSupport.notifications.successChange'));
        }
        if (fournisseurSupport.avertissements.length > 0) {
          fournisseurSupport.contacts = (await getAllByTiers(fournisseurSupport.id))
            .data.result.items;
          traductionMsgAvertissement(
            fournisseurSupport.avertissements,
            this.messagesAvertissement,
          );
          fournisseurSupport.dateSignatureMandatSepa = moment(
            fournisseurSupport.dateSignatureMandatSepa,
          ).toDate();
          this.fournisseurSupport = fournisseurSupport;
          this.popUpAvertissement = true;
          this.nomCommercial = fournisseurSupport.nomCommercial;
        } else await this.$router.push({ name: 'l.presse.fournisseur_support' });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, champsFournisseurTranslator);
          this.error = true;
          return;
        }
        throw e;
      }
    },
    selectionAdresseFacturationclient() {
      if (!this.fournisseurSupport.adresseFacturationDifferente) {
        this.fournisseurSupport.adresseFacturation = adresseGenerer();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Client' });
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.motifBlocage,
      ]);
      let fournisseurSupport = genererClient();
      fournisseurSupport.type = TIERS_TYPE_FOURNISSEUR;
      fournisseurSupport.sousTypes = [TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT];
      if (this.$route.params.id) {
        fournisseurSupport = (await get(this.$route.params.id)).data.result;
        this.nomCommercial = fournisseurSupport.nomCommercial;
        fournisseurSupport.contacts = (await getAllByTiers(fournisseurSupport.id))
          .data.result.items;
        await this.setAttachmentElementId({ id: fournisseurSupport.id });
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nomCommercial }));
      } else this.setInformationPage(this.$t('pagePresse.fournisseurSupport.creation'));
      initialize(fournisseurSupport);
      this.fournisseurSupport = fournisseurSupport;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
